export const darkTheme = {
  color: "white",
  backgroundColor: "black",
}

export const lightTheme = {
  backgroundColor: "white",
}